import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {Validator} from 'vee-validate';
import ClientService from './../../../clientmanagement/services/clientmanagement.service';
import Multiselect from 'vue-multiselect'
import iptracker from '../../../../views/components/commonfunction/iptracker';
import Utility from './../../../utility/services/utility.service';

export default {
  name: "updatebookingdetails",
  components: {
    Loader,
    Multiselect,
    iptracker
  },
  props: ["parentObj", "childcharges"],
  data: function () {
    return {
      accordianTab: { 1: false, 2: false },
      expanded: false,
      isLoading: false,
      useremail: "",
      subtabdisabledflag: true,
      client: null,
      clientname:null,
      shipmentId: '',
      isLoading:false,
      showClientDetails:false,
      Clientlist:[],
      clientid:"",
      clientbusinessdetailid:"",
      clientbusinessaccountid:"",
      oldclientbusinessaccountid:"",
      businessaccountname:"",
      ActiveContract:"",
      DestinationPincode:"",
      OriginPincode:"",
      ParentAWB:"",
      RouteMode:"",
      TruckLoadType:"",
      BookingMode:"",
      disablefields:true,
      showclient:false,
      comments:'',
      bookingmodecomments:'',
      shipmentStatus: "",
      userdetail:{},
      oldBookingMode: ""
    };
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("cargoAutoaccessuserdata");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.hubid = userdetail.hubID[0];
    this.getCompanyShortName();
  },
  methods: {
      async getCompanyShortName() {
        try {
          let InputPayload = {}
          var CompanyShortList = [];
          this.isLoading = true;
          let result = await ClientService.GetClientListByActiveContracts(InputPayload);
          CompanyShortList = result.data.data.rows;
          let tempArr = [];
          for (var i = 0; i < CompanyShortList.length; i++) {
            tempArr.push({
              'id': CompanyShortList[i].clientid,
              'label': CompanyShortList[i].clientcompanyname,
              'ContractId': CompanyShortList[i].id,
              'CompanyName': CompanyShortList[i].clientcompanyname,
              'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
              'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid,
            });
          }
          this.isLoading = false;
         this.Clientlist = tempArr.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);
        } catch (err) {
          console.log(err);
        }
      },
      async onSubmitSearch() {
        this.$validator.validateAll().then((result) => {
          if(result){
            this.expanded = false;
            this.subtabdisabledflag = true;
            this.accordianTab = { 1: false, 2: false };
            this.showclient = false;
            this.getclientDetails(event);
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
      },
      reset() {
        this.shipmentId = '';
        this.client = null;
        this.clientname = null;
        this.showclient = false;
        this.$validator.reset();
        this.comments = '';
        this.BookingMode = '';
        this.oldBookingMode = '';
        this.bookingmodecomments = '';
        this.TruckLoadType = "";
        this.subtabdisabledflag = true;
        this.ActiveContract = "";
        this.businessaccountname = "";
        this.clientbusinessdetailid = "";
        this.clientbusinessaccountid = "";
        this.clientid = "";
        this.expanded = false;
        this.accordianTab = { 1: false, 2: false };
      },
      async getclientDetails(){
        try{
          this.isLoading=true;
          let payload = {
            'awb': this.shipmentId
          }
          let result = await utility.getCargoClientDetails(payload);
          this.isLoading=false;
          if(result.data.code == 200){
            let clientDetails = result.data.data.ResultData;
            if(clientDetails.status=="Invalid"){
              this.$alertify.error("Shipment status is Invalid. So you can not update the booking details.");
              return false;
            }else if(clientDetails.isverified){
              this.$alertify.error("AWB Verification is already done for this shipment. So you can not update the booking details.");
              return false;
            }else if(clientDetails.bookingstatus!="Complete"){
              this.$alertify.error("AWB booking status is Pending/Rapid. Please complete the booking process.");
              return false;
            }else{
              this.accordianTab[1] = true;
              this.showclient = true;
              this.subtabdisabledflag = false;
              this.shipmentStatus = clientDetails.status;
              if(this.Clientlist.length==0){
                this.getCompanyShortName();
              }
              this.Clientlist.map(el =>{
                if(el.id == clientDetails.ClientID)
                this.client = el.label;
              })
              this.client = {
                id: clientDetails.ClientID,
                label:clientDetails.BusinessAccountName,
                ContractId:clientDetails.ActiveContractID,
                CompanyName:clientDetails.BusinessAccountName,
                ClientBusinessAccountId:clientDetails.ClientBusinessAccountId,
                ClientBusinessDetailId:clientDetails.ClientBusinessDetailId
              }

              let bookingmode;
              if(clientDetails.BookingMode.toLowerCase() == 'to pay' || clientDetails.BookingMode.toLowerCase() == 'topay'){
                  bookingmode = 'To Pay';
              }else{
                bookingmode = clientDetails.BookingMode
              }
              this.ActiveContract = clientDetails.ActiveContractID;
              this.businessaccountname =clientDetails.BusinessAccountName;
              this.clientbusinessdetailid = clientDetails.ClientBusinessDetailId;
              this.clientbusinessaccountid = clientDetails.ClientBusinessAccountId;
              this.oldclientbusinessaccountid = clientDetails.ClientBusinessAccountId;
              this.DestinationPincode = clientDetails.DestinationPincode;
              this.OriginPincode = clientDetails.OriginPincode;
              this.ParentAWB = clientDetails.ParentAWB;
              this.RouteMode = clientDetails.RouteMode;
              this.TruckLoadType = clientDetails.TruckLoadType;
              this.oldBookingMode = bookingmode;
              this.BookingMode = bookingmode;
              this.clientid = clientDetails.ClientID;
            }
          }
          else{
            this.$alertify.error(result.data.message);
          }
        }
        catch (err) {
          console.log(err);
          this.isLoading = false;
        }
      },
      async updateClient() {
        this.$validator.validateAll("clientnamechangeform").then((result) => {
          if(result){
            this.updateclientDetails();
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
      },
      async updateclientDetails(){
        try{
           this.isLoading = true;
           let payload = {
            'awb':this.shipmentId,
  	        'BusinessAccountName':this.businessaccountname,
  	        'ClientBusinessAccountId':this.clientbusinessaccountid,
  	        'ClientBusinessDetailId':this.clientbusinessdetailid.toString(),
  	        'ClientID':this.clientid,
  	        'ActiveContractID':this.ActiveContract,
  	        'LastModifiedBy':this.userName,
            'TruckLoadType':this.TruckLoadType,
            'RouteMode': this.RouteMode,
            'BookingMode':this.BookingMode,
            'shipmentstatus' : this.shipmentStatus,
            'comments':this.comments,
            'IsOpertionUse':1
           }
           let result = await utility.UpdateCargoClientDetails(payload);
           if(result.data.code == 200){
             this.oldclientbusinessaccountid = this.clientbusinessaccountid;
             this.comments = "";
             this.client = {
               id: this.clientid,
               label:this.businessaccountname,
               ContractId:this.ActiveContract,
               CompanyName:this.businessaccountname,
               ClientBusinessAccountId:this.clientbusinessaccountid,
               ClientBusinessDetailId:this.clientbusinessdetailid
             }
             this.$validator.reset();
             this.getTraceIP(payload);
             this.showclient = false;
             if(this.Clientlist.length==0){
               this.getCompanyShortName();
             }
             this.$alertify.success(result.data.data.ReturnMessage)
             this.isLoading=false;
           }
           else{
            this.$alertify.error(result.data.message)
           }
           this.isLoading=false;
         }
         catch (err) {
          console.log(err);
          this.isLoading = false;
        }
      },
     selectClient(data){
      if(data){
        this.ActiveContract = data.ContractId;
        this.businessaccountname = data.CompanyName;
        this.clientbusinessdetailid = data.ClientBusinessDetailId;
        this.clientbusinessaccountid = data.ClientBusinessAccountId;
        this.clientid = data.id
      }
    },
    async changeBookingMode() {
     this.$validator.validateAll("bookingmodechangeform").then((result) => {
       if(result){
         this.UpdateBookingMode();
       }
     }).catch(() => {
       console.log('errors exist', this.errors)
     });
    },
    async UpdateBookingMode(){
      try {
        this.isLoading = true;
        let InputPayload = {};
        InputPayload.awbnumber =   this.shipmentId;
        InputPayload.clientid = this.clientid;
        InputPayload.clientbusinessaccountid = this.clientbusinessaccountid;
        InputPayload.truckloadtype = this.TruckLoadType;
        InputPayload.bookingmode = this.BookingMode;
        InputPayload.routemode = this.RouteMode;
        InputPayload.username = this.userName;
        InputPayload.comments = this.bookingmodecomments;
        InputPayload.IsOpertionUse = 1;
        let result = await Utility.changeBookingMode(InputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
            this.oldBookingMode = this.BookingMode;
            this.bookingmodecomments = "";
            this.$validator.reset();
            this.getTraceIP(InputPayload);
            this.$alert(result.data.message,"","success");
        } else {
            this.$alert(result.data.message,"","error");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
     },
     getTraceIP(awbno) {
        let data =
          {
            "projectname": this.userdetail.project,
            "type": "web",
            "userid": this.userdetail.userid,
            "username": this.userdetail.username,
            "routeurl":'/changeclientname',
            "meta" : {
              "event" : `Change Client Name`,
              "data" : awbno
            }
        }
        let result = iptracker.getTraceIP(data);
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/updateBookingDetails/updateBookingDetails.component.js